import styled from 'styled-components';
import { ArrowDownIcon, FlexRow, SvgIcon } from '@make-software/cspr-design';
import React, { useState } from 'react';
import { BodyText } from '@block-explorer/ui';

const CollapsedRow = styled(FlexRow)<{ hasTopMargin?: boolean }>(
  ({ theme, hasTopMargin }) => ({
    height: '24px',
    marginTop: hasTopMargin ? '8px' : 'unset',
    '&:hover': {
      span: {
        color: theme.styleguideColors.contentRed,
      },
      [`${SvgIcon}`]: {
        path: {
          fill: theme.styleguideColors.contentRed,
        },
      },
    },
  })
);

interface ExpandCollapsedButtonProps {
  expandedLabel?: React.ReactNode;
  collapsedLabel: React.ReactNode;
  showArrow?: boolean;
  hasTopMargin?: boolean;
  onExpand?: (collapsed: boolean) => void;
}

export const ExpandCollapsedButton = ({
  expandedLabel,
  collapsedLabel,
  showArrow = true,
  hasTopMargin = true,
  onExpand,
}: ExpandCollapsedButtonProps) => {
  const [isCollapsed, setCollapsed] = useState<boolean>(true);

  return (
    <CollapsedRow
      align="center"
      onClick={() => {
        setCollapsed(!isCollapsed);
        onExpand && onExpand(!isCollapsed);
      }}
      hasTopMargin={hasTopMargin}
    >
      <BodyText size={3} variation="blue">
        {isCollapsed ? collapsedLabel : expandedLabel}
        {showArrow && (
          <SvgIcon
            src={ArrowDownIcon}
            alt={'Arrow icon'}
            marginLeft
            rotate={!isCollapsed}
          />
        )}
      </BodyText>
    </CollapsedRow>
  );
};

ExpandCollapsedButton.displayName = 'ExpandCollapsedButton';
export default ExpandCollapsedButton;
